import { AHIcon, AHText, Box, Circle } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { TeamIconCircle } from "../../../../components/mobile/TeamIconCircle";
import { LegacyListItem } from "../../components/ListItem";
import { KPIEditSectionsTeamListItem_Team$key } from "./__generated__/KPIEditSectionsTeamListItem_Team.graphql";

export function KPIEditSectionsTeamListItem(props: {
  isFirst: boolean;
  isLast: boolean;
  onPress(): void;
  team: KPIEditSectionsTeamListItem_Team$key;
}) {
  const team = useFragment(
    graphql`
      fragment KPIEditSectionsTeamListItem_Team on Team {
        ...TeamIconCircleComponent_Team
        name
      }
    `,
    props.team
  );

  return (
    <LegacyListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={props.onPress}
    >
      <Circle size="smallMedium" color="positive">
        <AHIcon type="add" color="surface" />
      </Circle>
      <Box spaceHorizontal="small">
        <Box style={{ height: "100%", width: 1 }} color="border-primary" />
      </Box>
      <TeamIconCircle team={team} size="smallMedium" />
      <AHText spaceLeft="small" type="list-item-title">
        {team.name}
      </AHText>
    </LegacyListItem>
  );
}
